import { BulkMessage } from "@/__generated__/types";

export const DEFAULT_INITIAL_RECORDS_ACTIVE_SCHEDULED = 10;

export const DATE_FORMAT = "PPP";
export const PLACEHOLDER_FALLBACK = "--";

export const getBulkMessageStatus = (
  bulkMessage: BulkMessage,
  now: number,
): "active" | "scheduled" => {
  const nowInSeconds = Math.floor(now);
  const startTime = bulkMessage.startSendingAt;
  const stopTime = bulkMessage.stopSendingAt;

  if (
    startTime &&
    stopTime &&
    startTime <= nowInSeconds &&
    stopTime > nowInSeconds
  ) {
    return "active";
  }
  return "scheduled";
};

export const getPageCount = (totalCount: number): number => {
  return Math.ceil(totalCount / DEFAULT_INITIAL_RECORDS_ACTIVE_SCHEDULED);
};
